import { render } from "./ShippingDeliveryPolicy.vue?vue&type=template&id=01fb12b4&scoped=true"
import script from "./ShippingDeliveryPolicy.vue?vue&type=script&lang=js"
export * from "./ShippingDeliveryPolicy.vue?vue&type=script&lang=js"

import "./ShippingDeliveryPolicy.vue?vue&type=style&index=0&id=01fb12b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fb12b4"]])

export default __exports__